import { useState, useEffect, useCallback } from "react";

export function useLocalStorage<T>(
  key: string,
  initialValue: unknown
): [
    value: T,
    setValue: React.Dispatch<React.SetStateAction<T>>,
    remove: () => void,
  ] {
  const [value, setValue] = useState<T>(() => {
    try {
      const item = localStorage.getItem(key);
      return item !== null ? JSON.parse(item) : initialValue;
    } catch (error) {
      // eslint-disable-next-line no-console
      console.error("error", key, error);
      return initialValue;
    }
  });

  useEffect(() => {
    try {
      localStorage.setItem(key, JSON.stringify(value));
    } catch (error) {
      // eslint-disable-next-line no-console
      console.error("error", key, error);
    }
  }, [key, value]);

  const remove = useCallback(() => {
    try {
      localStorage.removeItem(key);
      setValue(initialValue as T);
    } catch (error) {
      // eslint-disable-next-line no-console
      console.error("error", key, error);
    }
  }, [initialValue, key])

  return [value, setValue, remove];
}

